import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./attachment-manager.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./attachment-manager.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, forwardRef, Input } from "@angular/core";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AttachmentManagerConstants } from "./shared/constants/attachment-manager.constant";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let AttachmentManagerComponent = class AttachmentManagerComponent {
    formBuilder;
    setSelectAttachmentRequired = true;
    componentType;
    attachmentType;
    jobId;
    stepMetaData;
    hideFilter;
    hideAdd = false;
    hideDelete = false;
    hideAddAttachmentButton = false;
    hideDeleteAttachmentButton = false;
    anonymousAccess = { anonymousDocumentAccess: false, anonymousCommentRequestAccess: false };
    projectCycleId;
    attachmentListFormCtrl = AttachmentManagerConstants.ATTACHMENT_LIST_FORM_CTRL;
    attachmentArrayCtrl = AttachmentManagerConstants.ATTACHMENT_ARRAY;
    attachmentManagerFormControl;
    attachmentManagerFormSubscription;
    anonymousAccessMessage = AttachmentManagerConstants.ANONYMOUS_ACCESS_MESSAGE;
    get value() {
        return this.attachmentManagerFormControl.value;
    }
    set value(value) {
        this.onChange(value);
        this.onTouched();
    }
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
    }
    ngOnInit() {
        this.iniAttachmentManagerFormControl();
        this.attachmentManagerFormSubscription = this.attachmentManagerFormControl.valueChanges.subscribe((value) => {
            this.onChange(value);
            this.onTouched();
        });
    }
    iniAttachmentManagerFormControl() {
        this.attachmentManagerFormControl = this.formBuilder.group({
            attachmentList: []
        });
    }
    onChange = () => { };
    onTouched = () => { };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            this.attachmentManagerFormControl.reset();
        }
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    validate(_) {
        return this.attachmentManagerFormControl.valid
            ? null
            : { profile: { valid: false } };
    }
    static ctorParameters = () => [
        { type: FormBuilder }
    ];
    static propDecorators = {
        setSelectAttachmentRequired: [{ type: Input }],
        componentType: [{ type: Input }],
        attachmentType: [{ type: Input }],
        jobId: [{ type: Input }],
        stepMetaData: [{ type: Input }],
        hideFilter: [{ type: Input }],
        hideAdd: [{ type: Input }],
        hideDelete: [{ type: Input }],
        hideAddAttachmentButton: [{ type: Input }],
        hideDeleteAttachmentButton: [{ type: Input }],
        anonymousAccess: [{ type: Input }],
        projectCycleId: [{ type: Input }]
    };
};
AttachmentManagerComponent = __decorate([
    Component({
        selector: "app-attachment-manager",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AttachmentManagerComponent),
                multi: true,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => AttachmentManagerComponent),
                multi: true,
            },
        ],
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AttachmentManagerComponent);
export { AttachmentManagerComponent };
